import { SignalRTypes, SportEventsActionTypes, SearchActionTypes } from '../actions';

const initState = {
	error: null,
	loadingSportEvents: true,
	sportEvents: {},
	eventsIds: [],
	eventOdds: {},
	eventOddFields: {},
	eventData: null,
	betTypes: null,
	selectedValues: [],
	eventOddGroups: {},
	eventOddGroupIds: [],
	upcomingEvents: {},
	upcomingEventIds: [],
	drillDownTabs: [],
	searchResult: [],
	sportEventsClone:{}
};

const sportEvents = (state = initState, action) => {

	switch (action.type) {

		case SportEventsActionTypes.Init:
			return {
				...state,
				error: null,
				loadingSportEvents: true,
				sportEvents: {},
				eventsIds: [],
				eventOdds: {},
				eventOddFields: {},
				eventData: null,
				betTypes: null,
				selectedValues: [],
				eventOddGroups: {},
				eventOddGroupIds: [],
				upcomingEvents: {},
				upcomingEventIds: [],
				drillDownTabs: []

			}

		case SignalRTypes.SportEvents_Clear:
			return {
				...state,
				error: null,
				loadingSportEvents: false,
				sportEvents: {},
			}

		case SignalRTypes.SportEvents_Request:
		case SignalRTypes.TopBets_Request:
		case SignalRTypes.SportEvents_By_Date_Request:
			return {
				...state,
				error: null,
				loadingSportEvents: true,
				sportEvents: {},
				eventsIds: [],
				eventOdds: {},
				eventOddFields: {},
				eventData: null,
				betTypes: null,
				selectedValues: [],
				eventOddGroups: {},
				eventOddGroupIds: [],
				upcomingEvents: {},
				upcomingEventIds: [],
			}

		case SignalRTypes.AllBetTypes_Request:
			return {
				...state,
				sportEvents: {},
				eventsIds: [],
				eventOdds: {},
				eventOddFields: {},
				betTypes: null,
				selectedValues: [],
				eventOddGroups: {},
				eventOddGroupIds: [],
				upcomingEvents: {},
				upcomingEventIds: [],
				error: null,

			}

		case SignalRTypes.SportEvents_By_Date_Request:
			return {
				...state,
				sportEvents: {},
				eventsIds: [],
				eventOdds: {},
				eventOddFields: {},
				betTypes: null,
				eventData: null,
				selectedValues: [],
				eventOddGroups: {},
				eventOddGroupIds: [],
				upcomingEvents: {},
				upcomingEventIds: [],
				error: null,
				loadingSportEvents: true,


			}


		case SportEventsActionTypes.SportEvents_Success:
			return {
				...state,
				loadingSportEvents: false,
				sportEvents: action.sportEvents,
				eventOdds: action.eventOdds,
				betTypes: action.betTypes,
				eventsIds: action.eventsIds,
				selectedValues: action.selectedValues,
				eventOddGroups: action.eventOddGroups,
				eventOddGroupIds: action.eventOddGroupIds,
				upcomingEvents: action.upcomingEvents,
				upcomingEventIds: action.upcomingEventIds,
				error: null,
				drillDownTabs: action.drillDownTabs,
				specialGroupOdds: action.specialGroupOdds,
				specialOddFieldGroup: action.specialOddFieldGroup

			}

		case SportEventsActionTypes.SportEvents_Events_FeedChange:
			{
				return {
					...state,
					sportEvents: action.sportEvents,
					eventsIds: action.eventsIds,

				}
			}
			
		case SportEventsActionTypes.SportEvents_OddFields_Success:
			{
				return {
					...state,
					eventOddFields: action.eventOddFields,
				}
			}

		case SportEventsActionTypes.SportEvents_Odds_Success:
			{
				return {
					...state,
					eventOdds: action.eventOdds,
				}
			}
		case SportEventsActionTypes.SportEvents_Events_Success:
			{
				return {
					...state,
					sportEvents: action.sportEvents,
					eventsIds: action.eventsIds,

				}
			}
		case SportEventsActionTypes.SportEvents_Upcoming_Events_Success:
			{
				return {
					...state,
					upcomingEvents: action.upcomingEvents,
					upcomingEventIds: action.upcomingEventIds
				}
			}
		case SportEventsActionTypes.SportEvents_Groups_Success:
			{
				return {
					...state,
					eventOddGroups: action.eventOddGroups,
					eventOddGroupIds: action.eventOddGroupIds,
					drillDownTabs: action.drillDownTabs

				}
			}
		case SportEventsActionTypes.SportEvents_BetTypes_Success:
			{
				return {
					...state,
					betTypes: action.betTypes,

				}
			}


		case SportEventsActionTypes.SportEvents_Error:
			return {
				...state,
				loadingSportEvents: false,
				sportEvents: {},
				eventOdds: {},
				betTypes: [],
				eventsIds: [],
				selectedValues: [],
				eventOddGroups: {},
				eventOddGroupIds: [],
				upcomingEvents: {},
				upcomingEventIds: [],
				eventOddFields: {},
				error: action.error,
			}

		case SportEventsActionTypes.Set_Event:
			return {
				...state,
				eventData: action.item,
				drawEvents: action.drawEvents
			}


		case SportEventsActionTypes.SportEvents_Update:
			return {
				...state,
				sportEvents: action.sportEvents,
			}

		case SportEventsActionTypes.SportEvents_OnDropDownsChange:
			return {
				...state,
				selectedValues: action.selectedValues,
			}
		case SportEventsActionTypes.SportEvents_OnMobileBetFilterClick:
			return {
				...state,
				selectedValue: action.selectedValue,
			}
		case SearchActionTypes.GetSearchedData_Response:
			return {
				...state,
				searchResult: action.response
			}
		case SportEventsActionTypes.Sport_Get_Week_Match_Days_Request:
			return {
				...state,
				loadingWeekMatchDays: true,
			}
		case SportEventsActionTypes.Sport_Get_Week_Match_Days_Success:
			return {
				...state,
				loadingWeekMatchDays: false,
				weekMatchDaysError: undefined,
				weekMatchDays: action.weekMatchDays
			}
		case SportEventsActionTypes.Sport_Get_Week_Match_Days_Error:
			return {
				...state,
				loadingWeekMatchDays: false,
				weekMatchDaysError: action.weekMatchDaysError,
				weekMatchDays: undefined,
			}
		case SportEventsActionTypes.Get_Default_Live_Sport_Type_Request:
			return {
				...state,
				loadingDefaultLiveSport: true,
				defaultLiveSport: undefined,
				defaultLiveSportError:undefined
			}
		case SportEventsActionTypes.Get_Default_Live_Sport_Type_Success:
			return {
				...state,
				loadingDefaultLiveSport: false,
				defaultLiveSportError: undefined,
				defaultLiveSport: action.defaultLiveSport
			}
		case SportEventsActionTypes.Get_Default_Live_Sport_Type_Error:
			return {
				...state,
				loadingDefaultLiveSport: false,
				defaultLiveSportError: action.defaultLiveSportError,
				defaultLiveSport: undefined,
			}
		case SportEventsActionTypes.Filter_Sport_Events_Action:
			return {
				...state,
				sportEventsClone: state.sportEvents,
				sportEvents: action.filterType == 3 ? (state.sportEvents && Object.values(state.sportEvents).length > 0 && Object.fromEntries(Object.entries(state.sportEvents).filter(item=>   item[1].eventTournament.isFavorite || item[1].isHomeTeamFavorite || item[1].isAwayTeamFavorite || item[1].eventCategory.isFavorite))): state.sportEventsClone ? state.sportEventsClone: state.sportEvents,
				
			}
		case SportEventsActionTypes.Update_Favorite_Sport_Events:
			return {
				...state,
				sportEvents: state.sportEvents && Object.fromEntries(Object.entries(state.sportEvents).map(([eventId, event])=>  { 
					if(event.eventTournament.tournamentUId == action.tournamentUId){
						return [eventId, { ...event, eventTournament: {...event.eventTournament , isFavorite: !event.eventTournament.isFavorite } }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
				sportEventsClone: state.sportEventsClone && Object.fromEntries(Object.entries(state.sportEventsClone).map(([eventId, event])=>  { 
					if(event.eventTournament.tournamentUId == action.tournamentUId){
						return [eventId, { ...event, eventTournament: {...event.eventTournament , isFavorite: !event.eventTournament.isFavorite } }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
				
			}
		case SportEventsActionTypes.Update_Favorite_Team_For_Sport_Events:
			return {
				...state,
				sportEvents: state.sportEvents && Object.fromEntries(Object.entries(state.sportEvents).map(([eventId, event])=>  { 
					if(action.teamType == 'home' && event.eventHomeTeamId == action.teamId){
						return [eventId, { ...event, isHomeTeamFavorite: action.isFavorite }];
					}else if (action.teamType == 'away' && event.eventAwayTeamId == action.teamId){
						return [eventId, { ...event, isAwayTeamFavorite: action.isFavorite }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
				sportEventsClone: (state.sportEventsClone && Object.values(state.sportEventsClone).length > 0) ? Object.fromEntries(Object.entries(state.sportEventsClone).map(([eventId, event])=>  { 
					if(action.teamType == 'home' && event.eventHomeTeamId == action.teamId){
						return [eventId, { ...event, isHomeTeamFavorite: action.isFavorite }];
					}else if (action.teamType == 'away' && event.eventAwayTeamId == action.teamId){
						return [eventId, { ...event, isAwayTeamFavorite: action.isFavorite }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})):{},
				
			}
		case SportEventsActionTypes.Update_Favorite_Country_For_Sport_Events:
			return {
				...state,
				sportEvents: state.sportEvents && Object.fromEntries(Object.entries(state.sportEvents).map(([eventId, event])=>  { 
					if(event.eventCategory.sportCategoryUId == action.sportCategoryUId){
						return [eventId, { ...event, eventCategory: {...event.eventCategory , isFavorite: !event.eventCategory.isFavorite } }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
				sportEventsClone: state.sportEventsClone && Object.fromEntries(Object.entries(state.sportEventsClone).map(([eventId, event])=>  { 
					if(event.eventCategory.sportCategoryUId == action.sportCategoryUId){
						return [eventId, { ...event, eventCategory: {...event.eventCategory , isFavorite: !event.eventCategory.isFavorite } }];
					}else {
						return [eventId, event]; // Return the original entry pair
					}
				})),
				
			}

		default:
			return { ...state };

	}
}

export default sportEvents;